export const TENANT_TYPES = {
  CAMPAIGN: 'campaign',
  LEGISLATIVE: 'legislative',
};

export const detectTenantType = () => {
  const envTenantType = process.env.REACT_APP_TENANT_TYPE;
  if (envTenantType) {
    const normalized = envTenantType.toLowerCase();
    if (normalized === TENANT_TYPES.LEGISLATIVE) {
      return TENANT_TYPES.LEGISLATIVE;
    }
    if (normalized === TENANT_TYPES.CAMPAIGN) {
      return TENANT_TYPES.CAMPAIGN;
    }
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    if (hostname.includes('leg.rightinsight.org') || hostname.startsWith('leg.')) {
      return TENANT_TYPES.LEGISLATIVE;
    }
    
    return TENANT_TYPES.CAMPAIGN;
  }

  return TENANT_TYPES.CAMPAIGN;
};

export const isCampaignTenant = () => detectTenantType() === TENANT_TYPES.CAMPAIGN;
export const isLegislativeTenant = () => detectTenantType() === TENANT_TYPES.LEGISLATIVE;
